import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { AppBar, Toolbar } from '@mui/material';

import { useAuth } from '@/contexts/AuthProvider';

import { LANDING_ROUTES } from '@/config/routes';

import { LogoHomeButton } from '@/components/logo/LogoHomeButton';
import { Button } from '@/shared/button/Button';

import { useTrackUserEvents } from '@/tracking';

import { useStyles } from './Header.styles';

export const Header = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { isAuthenticated } = useAuth();

  const { trackChangeInPageEvent } = useTrackUserEvents();

  const goTo = (path: string) => () => {
    trackChangeInPageEvent?.(path);
    history.push(path);
  };

  return (
    <AppBar elevation={0} className={classes.header}>
      <Toolbar className={classes.toolbar}>
        <LogoHomeButton color="light" />
        <div className={classes.headerButtons}>
          {!isAuthenticated && (
            <>
              <Button onClick={goTo(LANDING_ROUTES.signin)} color="secondary" variant="text">
                {t('landing.header.signIn')}
              </Button>
              <Button
                onClick={goTo(LANDING_ROUTES.signup)}
                color="primary"
                variant="contained"
                className={classes.getStartedButton}
              >
                {t('landing.header.getStarted')}
              </Button>
            </>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
};
